import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

// Cookies -- https://www.npmjs.com/package/vue-cookies
// import VueCookies from 'vue-cookies'
// Vue.use(VueCookies)

// Bootstrap -- https://bootstrap-vue.js.org/docs
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)

import InfiniteLoading from 'vue-infinite-loading';
Vue.use(InfiniteLoading, { props: { spinner: 'bubbles'}});

// my global css
import './global.scss'

Vue.config.productionTip = false;

new Vue({
  router,                 // so that we can access this.$route and this.$router in any Vue component (though not sure it's working)
  store,                  // so that we can access this.$store in any Vue component
  render: (h) => h(App),
}).$mount('#app');
